import '../base';
import '../components/product/product-comparison';
